var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{ref:"refVueApexChart",staticClass:"mt-3",attrs:{"height":"250","options":_vm.visitorBarChartConfig,"series":[{ data: _vm.CrmEarningReportsYearlyOverviewSeries }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }